var map = {
	"./el-fondo-de-la-botella.jpg": "21a1",
	"./la-muerte-de-belle.jpg": "edab",
	"./los-postigos-verdes.jpg": "2cc5",
	"./maigret-duda.jpg": "b067",
	"./maigret-tiene-miedo.jpg": "d07c",
	"./maigret-y-la-vieja-dama.jpg": "42d8",
	"./tres-habitaciones-en-manhattan.jpg": "5382"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c76";